import React, { useState } from 'react'
import { isRootPassName } from '../../../utils/pqr/iwmRootMappingPreview'
import {
  IWM_ROOT_SWAPPED_BADGE_LABEL,
  iwmRootSwappedBadgeTitle
} from '../../../utils/pqr/swapIwmBugType'

function RootPassWithSwapBadge({ pass }: { pass: string }) {
  const [tipOpen, setTipOpen] = useState(false)
  const tip = iwmRootSwappedBadgeTitle()

  return (
    <span
      className="relative flex h-full min-h-[40px] w-full items-center justify-center"
      data-testid="wp-iwm-root-pass-cell"
    >
      <span className="text-center font-semibold text-text-grey">{pass}</span>
      <span
        data-testid="wp-iwm-root-swapped-badge"
        className="absolute right-0 top-0.5 z-20 cursor-default rounded border border-primary-200 bg-primary-50 px-1 py-px text-[8px] font-semibold uppercase leading-none tracking-wide text-primary-800"
        onMouseEnter={() => setTipOpen(true)}
        onMouseLeave={() => setTipOpen(false)}
        onFocus={() => setTipOpen(true)}
        onBlur={() => setTipOpen(false)}
        tabIndex={0}
        aria-label={tip}
      >
        {IWM_ROOT_SWAPPED_BADGE_LABEL}
        {tipOpen ? (
          <span
            role="tooltip"
            data-testid="wp-iwm-root-swapped-tooltip"
            className="pointer-events-none absolute right-0 top-full z-50 mt-1 w-56 rounded-md border border-[#E2E5EA] bg-white px-2.5 py-2 text-left text-[11px] font-normal normal-case tracking-normal text-text-grey shadow-md"
          >
            {tip}
          </span>
        ) : null}
      </span>
    </span>
  )
}

/** Pass label with optional tiny top-right Swapped badge when IWM Root flip is on. */
export function renderPassWithIwmSwapBadge(
  pass: string,
  swapIwmBugType: boolean
): React.ReactNode {
  if (!swapIwmBugType || !isRootPassName(pass)) return pass
  return <RootPassWithSwapBadge pass={pass} />
}
